export function handleStatusLabel(value) {
  if (value === null || value === undefined || value === '') return '未知状态'
  return { 0: '未处理', 2: '已确认', 1: '已关闭' }[String(value)] || '未知状态'
}

export function handleStatusTag(value) {
  const type = { 0: 'warning', 2: '', 1: 'success' }[String(value)]
  return type === undefined ? 'info' : type
}
